/** @module csi/widget/_svg/ModeTable */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dijit/form/Button",
	"dijit/_HasDropDown",
	"csi/locale",
	"../TableDimensions",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(declare,lang,domClass,Button,_HasDropDown,locale,TableDimensions,_Plugin,PluginFactory, util) {

	return PluginFactory.declare([Button, _Plugin, _HasDropDown], {
		"class": "csi-button-toggle",
		iconClass: "csiActionIcon svgIconTable",
		pluginName: "table",
		title: "CanvasTable",

		/**
		 * Create table dimensions widget.
		 */
		postCreate: function() {
			this.dropDown = new TableDimensions({
				initialSelectedRows: 1,
				initialSelectedColumns: 1,
				initialDisplayRows: 2,
				initialDisplayColumns: 5,
				maxRows: 10,
				maxColumns: 10,
				onClick: lang.hitch(this, this._onSetTableDimensions)
			});
			this.inherited(arguments);
		},

		_onSetTableDimensions: function() {
			var tableDimensions = this.dropDown._getTableDimensions();
			this.editor.setDrawMetadata(tableDimensions);
			this.editor.setDrawMode('rect', true, true, true);
			this.closeDropDown();
			this.dropDown.reset();
		},


		/**
		 * Set drag mode based on selected shape
		 */
		onClick: function() {
			this._setToggled(true);
		},

		/**
		 * Set toggle status; if use "checked" attribute, then drop-down button also gets styling which we don't want
		 */
		_setToggled: function(b) {
			domClass.toggle(this.domNode, "dijitChecked", !!b);
		},
	});
});
